import styled from '@emotion/styled'
import { IconButton } from '@mui/material'
import { theme as newTheme } from 'styles/theme/hav-theme'

export const IconButtonStyled = styled(IconButton)`
  color: ${newTheme.colors.neutral.light};

  .MuiSvgIcon-root {
    font-size: ${newTheme.icon.size.medium};
  }
`
